import { dropAllCookies, dropTargetingCookies } from 'util/cookie-utils'
import globalStore from './global-store'
import log, {
  LogLevel, setLogLevel as internalSetLogLevel, setLogTrace as internalSetLogTrace
} from 'util/logger'
import ssoService from 'services/sso-service'

// widgets affected by a change in sku. subdimension-teaser is as well, but the handling is
// done a little differently
const SET_TYPES = ['chatter', 'instant-answers', 'qa', 'reviews-summary', 'reviews-list']

// ideally would import from subdimension-teaser-loader, but that is causing the widget code to be
// included in page js even when it is not configured to be there
const subdimensionTeaserType = 'subdimension-teaser'

export function set(params: { sku: string }): void {
  if (!params || !params.sku) {
    log.error('Must specify sku for "set" (e.g. {sku: "abc"})')
    return
  }
  const previousSku = globalStore.sku
  globalStore.sku = params.sku
  // if the sku changed, check to make sure the affected widgets are loaded, if not load them
  if (previousSku !== globalStore.sku) {
    globalStore.loaders.forEach((loader) => {
      if (SET_TYPES.indexOf(loader.type) > -1 && !loader.getInstance()) {
        loader.initialize()
      } else if (loader.type === subdimensionTeaserType) {
        loader.getWidgetDivIds().forEach((divId) => {
          if (!loader.getInstances()[divId]) {
            loader.initialize(divId)
          }
        })
      }
    })
  }
}

// Used to load widgets after the page has loaded.  Covers case where divs do not exist on the
// page by the time dom is ready.  Can also be used in SPA situation where the html holding the
// widgets is removed and replaced with a new dom.
export function initialize(widgetType: string): void {
  globalStore.loaders.forEach((loader) => {
    // not all widgets have an initialize functiion (e.g. top-comments, feed-comment-capture)
    if (typeof loader.initialize === 'function' && (!widgetType || widgetType === loader.type)) {
      loader.type === subdimensionTeaserType ? loader.initializeAll() : loader.initialize()
    }
  })
}

export function setLogLevel(level: LogLevel): void {
  internalSetLogLevel(level)
}

export function setLogTrace(logTrace: boolean): void {
  internalSetLogTrace(logTrace)
}

// context is a base64 encoded json containing submissionToken, action, sku and optionally rating
export function ssoRegDone(params: { context: string; userDataToken: string }): void {
  if (!params || !params.context) {
    log.error('Must specify context for "ssoRegDone" (e.g. {context: "abc"})')
    return
  }
  ssoService.processSsoRegDone(params)
}

// context is a base64 encoded json containing sku and optionally rating
export function loggedInDataFnDone(params: { context: string; loggedInData: string }): void {
  if (!params || !params.context) {
    log.error('Must specify context for "loggedInDataFnDone" (e.g. {context: "abc"})')
    return
  }
  ssoService.processLoggedInDataDone(params)
}

export function disableAllCookies(): void {
  globalStore.disableAllCookies = true
  dropAllCookies()
}

export function enableAllCookies(): void {
  globalStore.disableAllCookies = false
  globalStore.disableTargetingCookies = false // in case it was disabled too
}

export function disableTargetingCookies(): void {
  globalStore.disableTargetingCookies = true
  dropTargetingCookies()
}

export function enableTargetingCookies(): void {
  globalStore.disableTargetingCookies = false
}
